import UserAvatar from './UserAvatar'
import { avatarColorIndex } from '@ofself/shell'

const hashColor = (name) => `var(--avatar-${avatarColorIndex(name || '')})`

// ONE renderer for a conversation's avatar — the single source of truth shared by the sidebar
// conversation list AND the chat panel's title (and future custom channel avatars). It draws the
// channel hashtag, the persona/plugin DM badges, or a person's UserAvatar, exactly like the
// sidebar. `size` (px) scales the whole thing; omit it for the default control size.
export default function ConvoAvatar({ convo, name, size, className = 'convo-avatar' }) {
  if (!convo) return null
  const type = convo._type || (
    convo.is_persona_dm ? 'persona_dm'
      : convo.is_plugin_dm ? 'plugin_dm'
        : (convo.is_dm || convo.is_group_dm) ? 'dm'
          : 'channel'
  )
  const nm = name || convo._name || convo.name || '?'
  const initial = type === 'channel' ? '#' : (convo._initial || (nm[0] || '?').toUpperCase())
  const box = size ? { width: size, height: size, minWidth: size, fontSize: Math.round(size * 0.5) } : undefined
  const glyph = size ? Math.round(size * 0.42) : 14
  // status badge (bot / plugin) — bottom-right, scaled with the avatar
  const bw = size ? Math.max(8, Math.round(size * 0.46)) : 10
  const bs = size ? Math.max(5, Math.round(size * 0.28)) : 6
  const badge = (path) => (
    <span style={{
      position: 'absolute', bottom: -1, right: -1, width: bw, height: bw, borderRadius: '50%',
      background: 'var(--accent)', border: '2px solid var(--bg-primary, #fff)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <svg width={bs} height={bs} viewBox="0 0 24 24" fill="#fff" stroke="none"><path d={path} /></svg>
    </span>
  )

  if (type === 'channel') {
    return (
      <div className={`${className} convo-avatar-channel`} style={{ '--av-color': hashColor(nm), ...box }}>
        <svg width={glyph} height={glyph} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="4" y1="9" x2="20" y2="9" /><line x1="4" y1="15" x2="20" y2="15" />
          <line x1="10" y1="3" x2="8" y2="21" /><line x1="16" y1="3" x2="14" y2="21" />
        </svg>
      </div>
    )
  }
  if (type === 'persona_dm') {
    return (
      <div className={className} style={{ position: 'relative', ...box }}>
        {initial}
        {badge('M12 2a2 2 0 0 1 2 2c0 .74-.4 1.39-1 1.73V7h1a7 7 0 0 1 7 7h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1.07A7.001 7.001 0 0 1 14 23h-4a7.001 7.001 0 0 1-6.93-4H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a7 7 0 0 1 7-7h1V5.73c-.6-.34-1-.99-1-1.73a2 2 0 0 1 2-2z')}
      </div>
    )
  }
  if (type === 'plugin_dm') {
    return (
      <div className={className} style={{ position: 'relative', ...box }}>
        {initial}
        {badge('M13 2L3 14h9l-1 8 10-12h-9l1-8z')}
      </div>
    )
  }
  return (
    <UserAvatar
      userID={convo.other_user_id}
      avatarUrl={convo.other_user_avatar_url}
      initials={initial}
      color={convo._avatarColor || hashColor(nm)}
      size={size}
      className={className}
    />
  )
}
